import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { withTranslation } from "react-i18next";
const ESRSSidebar = ({ t }) => {
    return (
        <div className='Esrs_sidebar left-44'>
            <ul>
                <li>
                    <a href='#'>CLIMATE CHANGE  </a>
                </li>
                <li>
                    <a href='#'>POLLUTION</a>
                </li>
                <li>
                    <a href='#'>BIODIVERSITY AND ECOSYSTEMS</a>
                </li>
            </ul>
            
        </div>
    );
}

export default withTranslation()(ESRSSidebar);